import { render } from "./ArticoliJoomla.vue?vue&type=template&id=6da5d3e4"
import script from "./ArticoliJoomla.vue?vue&type=script&lang=js"
export * from "./ArticoliJoomla.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__